/* =============================================
   SPARKLES & RAINBOWS THEME JS
   ============================================= */

(function () {
  'use strict';

  /* ── Sparkle Particle System ── */
  const SparkleSystem = {
    colors: ['#ff0080', '#ff4500', '#ffd700', '#00cc44', '#0099ff', '#8b00ff', '#ff69b4', '#fff700'],
    shapes: ['✦', '✧', '★', '⋆', '✸', '✺', '❋', '✼', '⬟', '◆'],

    createSparkle(x, y) {
      const el = document.createElement('div');
      el.className = 'sparkle';
      el.textContent = this.shapes[Math.floor(Math.random() * this.shapes.length)];
      el.style.cssText = `
        left: ${x}px;
        top: ${y}px;
        position: fixed;
        pointer-events: none;
        z-index: 9998;
        font-size: ${Math.random() * 16 + 10}px;
        color: ${this.colors[Math.floor(Math.random() * this.colors.length)]};
        animation: sparkle-fall ${Math.random() * 0.8 + 0.8}s ease-out forwards;
        transform-origin: center;
      `;
      document.body.appendChild(el);
      el.addEventListener('animationend', () => el.remove());
    },

    burst(x, y, count = 8) {
      for (let i = 0; i < count; i++) {
        const offsetX = (Math.random() - 0.5) * 60;
        const offsetY = (Math.random() - 0.5) * 60;
        setTimeout(() => this.createSparkle(x + offsetX, y + offsetY), i * 40);
      }
    },

    init() {
      let lastX = 0, lastY = 0, frameCount = 0;
      document.addEventListener('mousemove', (e) => {
        frameCount++;
        if (frameCount % 3 !== 0) return;
        const dx = e.clientX - lastX;
        const dy = e.clientY - lastY;
        const speed = Math.sqrt(dx * dx + dy * dy);
        if (speed > 8) {
          this.createSparkle(e.clientX, e.clientY);
          lastX = e.clientX;
          lastY = e.clientY;
        }
      });

      document.addEventListener('click', (e) => {
        this.burst(e.clientX, e.clientY, 12);
      });
    }
  };

  /* ── Canvas Sparkle Background ── */
  const CanvasSparkles = {
    particles: [],

    init() {
      const canvas = document.getElementById('sparkle-canvas');
      if (!canvas) return;
      const ctx = canvas.getContext('2d');

      const resize = () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
      };
      resize();
      window.addEventListener('resize', resize);

      for (let i = 0; i < 60; i++) {
        this.particles.push(this.newParticle(canvas));
      }

      const animate = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        this.particles.forEach((p, i) => {
          p.y -= p.speed;
          p.x += Math.sin(p.wobble + Date.now() * 0.001) * 0.5;
          p.wobble += 0.02;
          p.life -= 0.003;

          if (p.life <= 0 || p.y < -10) {
            this.particles[i] = this.newParticle(canvas);
            return;
          }

          ctx.save();
          ctx.globalAlpha = p.life * 0.6;
          ctx.fillStyle = p.color;
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rotation);
          p.rotation += p.rotSpeed;
          this.drawStar(ctx, 0, 0, p.size, 4);
          ctx.restore();
        });
        requestAnimationFrame(animate);
      };
      animate();
    },

    newParticle(canvas) {
      const colors = ['#ff0080', '#ff4500', '#ffd700', '#00cc44', '#0099ff', '#8b00ff', '#fff700', '#ff69b4'];
      return {
        x: Math.random() * canvas.width,
        y: canvas.height + 10,
        speed: Math.random() * 1.5 + 0.5,
        size: Math.random() * 4 + 2,
        color: colors[Math.floor(Math.random() * colors.length)],
        wobble: Math.random() * Math.PI * 2,
        rotation: Math.random() * Math.PI * 2,
        rotSpeed: (Math.random() - 0.5) * 0.1,
        life: Math.random() * 0.5 + 0.5
      };
    },

    drawStar(ctx, cx, cy, r, points) {
      ctx.beginPath();
      for (let i = 0; i < points * 2; i++) {
        const angle = (i * Math.PI) / points - Math.PI / 2;
        const radius = i % 2 === 0 ? r : r * 0.4;
        const x = cx + Math.cos(angle) * radius;
        const y = cy + Math.sin(angle) * radius;
        i === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
      }
      ctx.closePath();
      ctx.fill();
    }
  };

  /* ── Scroll Animations ── */
  const ScrollAnimations = {
    init() {
      const elements = document.querySelectorAll('[data-animate]');
      if (!elements.length) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry, i) => {
          if (entry.isIntersecting) {
            setTimeout(() => entry.target.classList.add('visible'), i * 80);
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

      elements.forEach(el => observer.observe(el));
    }
  };

  /* ── Mobile Menu ── */
  const MobileMenu = {
    init() {
      const btn = document.querySelector('.mobile-menu-btn');
      const nav = document.querySelector('.mobile-nav');
      const overlay = document.querySelector('.mobile-nav-overlay');
      if (!btn || !nav) return;

      const open = () => { nav.classList.add('open'); overlay?.classList.add('open'); document.body.style.overflow = 'hidden'; };
      const close = () => { nav.classList.remove('open'); overlay?.classList.remove('open'); document.body.style.overflow = ''; };

      btn.addEventListener('click', open);
      overlay?.addEventListener('click', close);
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    }
  };

  /* ── Cart Drawer ── */
  const CartDrawer = {
    init() {
      const cartBtns = document.querySelectorAll('[data-cart-open]');
      const drawer = document.querySelector('.cart-drawer');
      const overlay = document.querySelector('.cart-drawer-overlay');
      const closeBtn = document.querySelector('.cart-drawer-close');
      if (!drawer) return;

      const open = () => { drawer.classList.add('open'); overlay?.classList.add('open'); document.body.style.overflow = 'hidden'; };
      const close = () => { drawer.classList.remove('open'); overlay?.classList.remove('open'); document.body.style.overflow = ''; };

      cartBtns.forEach(btn => btn.addEventListener('click', open));
      closeBtn?.addEventListener('click', close);
      overlay?.addEventListener('click', close);
    }
  };

  /* ── Add to Cart ── */
  const AddToCart = {
    init() {
      document.querySelectorAll('.add-to-cart-btn').forEach(btn => {
        btn.addEventListener('click', async (e) => {
          const originalText = btn.innerHTML;
          const variantId = btn.dataset.variantId;
          if (!variantId) return;

          btn.innerHTML = '✨ Adding...';
          btn.disabled = true;

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: variantId, quantity: 1 })
            });

            if (res.ok) {
              btn.innerHTML = '🌈 Added!';
              SparkleSystem.burst(e.clientX, e.clientY, 16);
              CartDrawer.updateCount();
              setTimeout(() => { btn.innerHTML = originalText; btn.disabled = false; }, 2000);
            } else {
              throw new Error('Failed');
            }
          } catch {
            btn.innerHTML = '❌ Error';
            setTimeout(() => { btn.innerHTML = originalText; btn.disabled = false; }, 2000);
          }
        });
      });
    }
  };

  /* ── Cart Count ── */
  CartDrawer.updateCount = async function () {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (_) {}
  };

  /* ── Product Gallery ── */
  const ProductGallery = {
    init() {
      const thumbs = document.querySelectorAll('.product-thumb');
      const mainImg = document.querySelector('.product-main-image img');
      if (!thumbs.length || !mainImg) return;

      thumbs.forEach(thumb => {
        thumb.addEventListener('click', () => {
          thumbs.forEach(t => t.classList.remove('active'));
          thumb.classList.add('active');
          const src = thumb.dataset.src;
          if (src) {
            mainImg.style.opacity = '0';
            mainImg.style.transition = 'opacity 0.3s ease';
            setTimeout(() => {
              mainImg.src = src;
              mainImg.style.opacity = '1';
            }, 150);
          }
        });
      });
    }
  };

  /* ── Variant Selector ── */
  const VariantSelector = {
    init() {
      this.picker = document.querySelector('[data-variant-picker]');
      const data = document.querySelector('[data-variant-data]');
      if (!this.picker || !data) return;

      try {
        this.variants = JSON.parse(data.textContent);
      } catch {
        return; // Leave the server-rendered variant in place rather than guessing.
      }

      this.groups = [...this.picker.querySelectorAll('.variant-options')]
        .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition);
      this.idInput = document.querySelector('#product-form [name="id"]');
      this.priceEl = document.querySelector('[data-price]');
      this.compareEl = document.querySelector('[data-compare-price]');
      this.savingsEl = document.querySelector('[data-savings]');
      this.addBtn = document.querySelector('.add-to-cart-btn');
      this.buyBtn = document.querySelector('#product-form .btn-dark');

      this.picker.querySelectorAll('.variant-btn').forEach(btn => {
        btn.addEventListener('click', () => {
          const group = btn.closest('.variant-options');
          group.querySelectorAll('.variant-btn').forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          const rect = btn.getBoundingClientRect();
          SparkleSystem.burst(rect.left + btn.offsetWidth / 2, rect.top + btn.offsetHeight / 2, 6);
          this.apply();
        });
      });
    },

    selected() {
      return this.groups.map(group => {
        const active = group.querySelector('.variant-btn.active');
        return active ? active.dataset.value : null;
      });
    },

    apply() {
      const chosen = this.selected();
      const variant = this.variants.find(v =>
        v.options.length === chosen.length && v.options.every((opt, i) => opt === chosen[i])
      );

      // No such combination exists — block checkout rather than sell the wrong thing.
      if (!variant) {
        this.setBuyable(false, 'Unavailable');
        return;
      }

      if (this.idInput) this.idInput.value = variant.id;
      if (this.addBtn) this.addBtn.dataset.variantId = variant.id;
      if (this.priceEl) this.priceEl.textContent = variant.price;

      if (this.compareEl) {
        this.compareEl.textContent = variant.comparePrice;
        this.compareEl.hidden = !variant.onSale;
      }
      if (this.savingsEl) {
        this.savingsEl.textContent = 'Save ' + variant.savings;
        this.savingsEl.hidden = !variant.onSale;
      }

      this.setBuyable(variant.available, variant.available ? 'Add to Cart ✦' : 'Sold Out');

      // Keep the URL shareable and correct on reload.
      const url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    },

    setBuyable(available, label) {
      if (this.addBtn) {
        this.addBtn.disabled = !available;
        this.addBtn.setAttribute('aria-disabled', String(!available));
        this.addBtn.textContent = label;
      }
      if (this.buyBtn) {
        this.buyBtn.disabled = !available;
        this.buyBtn.setAttribute('aria-disabled', String(!available));
      }
    }
  };

  /* ── Newsletter ── */
  const Newsletter = {
    init() {
      // #newsletter-form is the <form>; .newsletter-form is a <div> inside it.
      // Binding to the class meant submit never fired, FormData came back empty,
      // and form.action was undefined.
      const form = document.getElementById('newsletter-form');
      if (!form) return;
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const input = form.querySelector('.newsletter-input');
        const btn = form.querySelector('.btn');
        if (!input?.value) return;

        btn.textContent = '✨ Subscribing...';
        btn.disabled = true;

        // Shopify newsletter form action
        const formData = new FormData(form);
        try {
          const res = await fetch(form.action, { method: 'POST', body: formData });
          if (!res.ok) throw new Error('Signup failed');
          btn.textContent = '🌈 You\'re in!';
          input.value = '';
          SparkleSystem.burst(
            btn.getBoundingClientRect().left + btn.offsetWidth / 2,
            btn.getBoundingClientRect().top,
            20
          );
        } catch {
          btn.textContent = 'Subscribe ✦';
          btn.disabled = false;
        }
      });
    }
  };

  /* ── Rainbow Arc Builder ── */
  const RainbowArc = {
    init() {
      document.querySelectorAll('.rainbow-arc').forEach(arc => {
        const colors = ['#ff0000', '#ff7700', '#ffff00', '#00cc00', '#0000ff', '#8b00ff'];
        const stripeWidth = 14;
        colors.forEach((color, i) => {
          const stripe = document.createElement('div');
          const inset = i * stripeWidth;
          stripe.className = 'rainbow-arc-stripe';
          stripe.style.cssText = `
            border-width: ${stripeWidth}px;
            border-color: ${color};
            inset: ${inset}px ${inset}px 0;
          `;
          arc.appendChild(stripe);
        });
      });
    }
  };

  /* ── Parallax Hero Blobs ── */
  const ParallaxBlobs = {
    init() {
      const blobs = document.querySelectorAll('.hero-blob');
      if (!blobs.length) return;
      document.addEventListener('mousemove', (e) => {
        const cx = window.innerWidth / 2;
        const cy = window.innerHeight / 2;
        const dx = (e.clientX - cx) / cx;
        const dy = (e.clientY - cy) / cy;
        blobs.forEach((blob, i) => {
          const factor = (i + 1) * 8;
          blob.style.transform = `translate(${dx * factor}px, ${dy * factor}px)`;
        });
      });
    }
  };

  /* ── Share (Instagram / OS share sheet) ── */
  const ShareProduct = {
    init() {
      document.querySelectorAll('[data-share]').forEach((btn) => {
        btn.addEventListener('click', () => this.share(btn));
      });
    },

    async share(btn) {
      const url = btn.dataset.shareUrl;
      const title = btn.dataset.shareTitle;

      // Instagram has no web share URL. The OS share sheet lists it on mobile;
      // on desktop the best we can do is put the link on the clipboard.
      if (navigator.share) {
        try {
          await navigator.share({ title, url });
          return;
        } catch (err) {
          if (err.name === 'AbortError') return;
        }
      }

      try {
        await navigator.clipboard.writeText(url);
        this.flash(btn, 'Link copied ✦');
      } catch (err) {
        this.flash(btn, 'Copy failed');
      }
    },

    flash(btn, message) {
      if (!btn.dataset.originalLabel) btn.dataset.originalLabel = btn.textContent.trim();
      btn.textContent = message;
      setTimeout(() => { btn.textContent = btn.dataset.originalLabel; }, 2000);
    }
  };

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', () => {
    SparkleSystem.init();
    CanvasSparkles.init();
    ScrollAnimations.init();
    MobileMenu.init();
    CartDrawer.init();
    CartDrawer.updateCount();
    AddToCart.init();
    ProductGallery.init();
    VariantSelector.init();
    Newsletter.init();
    RainbowArc.init();
    ParallaxBlobs.init();
    ShareProduct.init();
  });
})();
